
import FLOWER_1 from '../../assets/card-images/flower-1.svg';
import FLOWER_2 from '../../assets/card-images/flower-2.svg';
import FLOWER_3 from '../../assets/card-images/flower-3.svg';
import FLOWER_4 from '../../assets/card-images/flower-4.svg';
import FLOWER_5 from '../../assets/card-images/flower-5.svg';
import FLOWER_6 from '../../assets/card-images/flower-6.svg';
import FLOWER_7 from '../../assets/card-images/flower-7.svg';
import FLOWER_8 from '../../assets/card-images/flower-8.svg';
import FLOWER_9 from '../../assets/card-images/flower-9.svg';
import FLOWER_10 from '../../assets/card-images/flower-10.svg';
import FLOWER_11 from '../../assets/card-images/flower-11.svg';
import FLOWER_12 from '../../assets/card-images/flower-12.svg';
import FLOWER_13 from '../../assets/card-images/flower-13.svg';
import FLOWER_14 from '../../assets/card-images/flower-14.svg';
import FLOWER_15 from '../../assets/card-images/flower-15.svg';
import FLOWER_16 from '../../assets/card-images/flower-16.svg';
import FLOWER_17 from '../../assets/card-images/flower-17.svg';
import FLOWER_18 from '../../assets/card-images/flower-18.svg';
import FLOWER_19 from '../../assets/card-images/flower-19.svg';
import FLOWER_20 from '../../assets/card-images/flower-20.svg';

export const GAME_IMAGES = {
    flower_1 : FLOWER_1,
    flower_2 : FLOWER_2,
    flower_3 : FLOWER_3,
    flower_4 : FLOWER_4,
    flower_5 : FLOWER_5,
    flower_6 : FLOWER_6,
    flower_7 : FLOWER_7,
    flower_8 : FLOWER_8,
    flower_9 : FLOWER_9,
    flower_10 : FLOWER_10,
    flower_11 : FLOWER_11,
    flower_12 : FLOWER_12,
    flower_13 : FLOWER_13,
    flower_14 : FLOWER_14,
    flower_15 : FLOWER_15,
    flower_16 : FLOWER_16,
    flower_17 : FLOWER_17,
    flower_18 : FLOWER_18,
    flower_19 : FLOWER_19,
    flower_20 : FLOWER_20
}

